// config.js
export const apiURL = "https://portalapp.ummudhardha.lk";
export const apiURL1 = "https://portalapp.ummudhardha.lk";
// export const onlineHost = "https://portalapp.ummudhardha.lk";
//localHost is: http://localhost:3000
